import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, User, LayoutDashboard } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const {
    isAuthenticated
  } = useAuth();
  const isHome = location.pathname === '/';
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const headerClass = `sticky top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || !isHome ? 'bg-white shadow-soft py-3' : 'bg-transparent py-5'}`;
  const textClass = isScrolled || !isHome ? 'text-text' : 'text-white';
  const logoClass = isScrolled || !isHome ? 'text-primary-900' : 'text-white';
  return <header className={headerClass} data-id="element-229">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-230">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 z-50" data-id="element-231">
          <div className={`w-8 h-8 rounded flex items-center justify-center font-serif font-bold text-xl ${isScrolled || !isHome ? 'bg-primary-900 text-secondary' : 'bg-white text-primary-900'}`} data-id="element-232">
            A
          </div>
          <span className={`font-serif font-bold text-2xl tracking-tight ${logoClass}`} data-id="element-233">
            AMU
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-234">
          <Link to="/explore" className={`text-sm font-medium hover:text-secondary transition-colors ${textClass}`} data-id="element-235">
            Explore
          </Link>
          <Link to="/map" className={`text-sm font-medium hover:text-secondary transition-colors ${textClass}`} data-id="element-236">
            Map View
          </Link>
          <Link to="/about" className={`text-sm font-medium hover:text-secondary transition-colors ${textClass}`} data-id="element-237">
            About
          </Link>
          <Link to="/contact" className={`text-sm font-medium hover:text-secondary transition-colors ${textClass}`} data-id="element-238">
            Contact
          </Link>
        </nav>

        {/* Desktop Actions */}
        <div className="hidden md:flex items-center gap-4" data-id="element-239">
          {isAuthenticated ? <>
              <Link to="/dashboard/buyer" className={`text-sm font-medium flex items-center gap-2 hover:text-secondary transition-colors ${textClass}`} data-id="element-240">
                <LayoutDashboard size={16} data-id="element-241" />
                Dashboard
              </Link>
              <Link to="/list-property" className="bg-secondary hover:bg-secondary-dark text-white px-5 py-2 rounded-lg text-sm font-semibold transition-colors shadow-glow" data-id="element-242">
                List Property
              </Link>
            </> : <Link to="/login" className={`text-sm font-medium flex items-center gap-2 hover:text-secondary transition-colors ${textClass}`} data-id="element-243">
              <User size={16} data-id="element-244" />
              Login
            </Link>}
        </div>

        {/* Mobile Menu Toggle */}
        <button className={`md:hidden z-50 ${textClass}`} onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-245">
          {mobileMenuOpen ? <X size={24} className={isScrolled || !isHome ? 'text-text' : 'text-text'} data-id="element-246" /> : <Menu size={24} data-id="element-247" />}
        </button>

        {/* Mobile Menu */}
        {mobileMenuOpen && <div className="fixed inset-0 bg-white z-40 pt-24 px-6 flex flex-col gap-6 md:hidden" data-id="element-248">
            <Link to="/explore" onClick={() => setMobileMenuOpen(false)} className="text-xl font-serif text-primary-900 border-b border-neutral-200 pb-4" data-id="element-249">
              Explore Properties
            </Link>
            <Link to="/map" onClick={() => setMobileMenuOpen(false)} className="text-xl font-serif text-primary-900 border-b border-neutral-200 pb-4" data-id="element-250">
              Map View
            </Link>
            <Link to="/about" onClick={() => setMobileMenuOpen(false)} className="text-xl font-serif text-primary-900 border-b border-neutral-200 pb-4" data-id="element-251">
              About AMU
            </Link>
            <Link to="/contact" onClick={() => setMobileMenuOpen(false)} className="text-xl font-serif text-primary-900 border-b border-neutral-200 pb-4" data-id="element-252">
              Contact
            </Link>

            <div className="mt-auto pb-8 flex flex-col gap-4" data-id="element-253">
              {isAuthenticated ? <>
                  <Link to="/dashboard/buyer" onClick={() => setMobileMenuOpen(false)} className="w-full py-3 text-center border border-primary-900 text-primary-900 rounded-lg font-medium" data-id="element-254">
                    Go to Dashboard
                  </Link>
                  <Link to="/list-property" onClick={() => setMobileMenuOpen(false)} className="w-full py-3 text-center bg-secondary text-white rounded-lg font-medium" data-id="element-255">
                    List Property
                  </Link>
                </> : <Link to="/login" onClick={() => setMobileMenuOpen(false)} className="w-full py-3 text-center border border-primary-900 text-primary-900 rounded-lg font-medium" data-id="element-256">
                  Login / Register
                </Link>}
            </div>
          </div>}
      </div>
    </header>;
};